/** mezuzi 241.0 SATC-WA (Home 50 Report 442, Head 114.0 GO on A): below 750 the phone sticky add-to-cart bar is full width at the
 *  bottom and the WhatsApp app bubble (fixed, bottom 20) sat on its thumbnail. While the bar is shown this writes html[data-satc-shown]
 *  and --satc-h (the bar's height); base.css lifts the bubble by it (the 'בועת הוואטסאפ' block). It only reads the vendor bar -
 *  sticky-add-to-cart.js is not edited. */
const host = document.querySelector('sticky-add-to-cart');
const bar = host && host.querySelector('[ref="stickyBar"]');
if (bar) {
  const narrow = window.matchMedia('(max-width: 749px)');
  const root = document.documentElement;
  const sync = () => {
    const on = narrow.matches && bar.dataset.stuck === 'true' && host.dataset.variantAvailable === 'true';
    if (on) root.style.setProperty('--satc-h', `${bar.offsetHeight}px`);
    root.toggleAttribute('data-satc-shown', on);
  };
  new MutationObserver(sync).observe(bar, { attributes: true, attributeFilter: ['data-stuck'] });
  new MutationObserver(sync).observe(host, { attributes: true, attributeFilter: ['data-variant-available'] });
  narrow.addEventListener('change', sync);
  sync();
}
